import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, ShoppingBag, User, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { useCart } from "@/context/CartContext";
import { useDict } from "@/i18n/dict";
import { NAV } from "@/constants/testIds";
import Logo from "@/components/Logo";

export default function Navbar() {
  const { user } = useAuth();
  const { lang, toggle } = useLang();
  const { count, setOpen } = useCart();
  const t = useDict(lang);
  const [mobile, setMobile] = useState(false);
  const navigate = useNavigate();

  const linkClass = ({ isActive }) => `nav-link ${isActive ? "active" : ""}`;

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-5 flex items-center justify-between">
        <Link to="/" className="flex items-center">
          <Logo />
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/recipes" data-testid={NAV.recipes} className={linkClass}>{t.nav.recipes}</NavLink>
          <NavLink to="/shop" data-testid={NAV.shop} className={linkClass}>{t.nav.shop}</NavLink>
          <NavLink to="/submit" data-testid={NAV.submit} className={linkClass}>{t.nav.submit}</NavLink>
        </nav>

        <div className="flex items-center gap-5">
          <button
            data-testid={NAV.langToggle}
            onClick={toggle}
            className="text-xs tracking-[0.22em] uppercase font-medium hover:text-[color:var(--navy)] transition-colors"
          >
            {lang === "fr" ? "EN" : "FR"}
          </button>
          {user ? (
            <Link to="/profile" data-testid={NAV.profile} aria-label="Profile" className="hover:text-[color:var(--navy)] transition-colors">
              <User size={18} />
            </Link>
          ) : (
            <Link to="/auth" data-testid={NAV.login} className="text-xs tracking-[0.22em] uppercase font-medium hidden sm:inline">
              {t.nav.login}
            </Link>
          )}
          <button
            data-testid={NAV.cart}
            aria-label="Cart"
            onClick={() => setOpen(true)}
            className="relative hover:text-[color:var(--navy)] transition-colors"
          >
            <ShoppingBag size={18} />
            {count > 0 && (
              <span className="absolute -top-2 -right-2 bg-[color:var(--red)] text-white text-[10px] rounded-full w-4 h-4 flex items-center justify-center font-medium">
                {count}
              </span>
            )}
          </button>
          <button data-testid={NAV.mobileMenu} className="md:hidden" onClick={() => setMobile((m) => !m)}>
            {mobile ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>
      {mobile && (
        <div className="md:hidden border-t border-[color:rgba(0,16,48,0.08)] bg-[var(--bg)] px-6 py-6 flex flex-col gap-5">
          <NavLink to="/recipes" onClick={() => setMobile(false)} className="nav-link">{t.nav.recipes}</NavLink>
          <NavLink to="/shop" onClick={() => setMobile(false)} className="nav-link">{t.nav.shop}</NavLink>
          <NavLink to="/submit" onClick={() => setMobile(false)} className="nav-link">{t.nav.submit}</NavLink>
          {!user && <NavLink to="/auth" onClick={() => setMobile(false)} className="nav-link">{t.nav.login}</NavLink>}
        </div>
      )}
    </header>
  );
}
